import { render, staticRenderFns } from "./CommodityAnalysis.vue?vue&type=template&id=113d31a5&"
import script from "./CommodityAnalysis.vue?vue&type=script&lang=js&"
export * from "./CommodityAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./CommodityAnalysis.vue?vue&type=style&index=0&id=113d31a5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports